import { ReactNode } from "react";
import * as Sentry from "@sentry/react";

import Error500 from "../../pages/Error500";

const ErrorBoundary = ({ children }: { children: ReactNode }) => {
  return (
    <Sentry.ErrorBoundary fallback={<Error500 />}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
